import React from 'react';
import { connect } from 'react-redux';
import Modal from 'react-responsive-modal';
import { Form } from 'react-form';
import Translate from 'translate';
import async from 'async';

import ChannelCaseService from 'services/ChannelCaseService';
import { FormGroup, Text, Textarea, Select } from 'components/FormElements';
import { toggleAlertError, toggleLoading } from 'stores/actions';
import { required, validPhoneLEC } from 'constants/InputErrors';
import IncmsService from 'services/IncmsService';

class AddImsLECModal extends React.Component {
  constructor( props ) {
    super( props );

    this.state = {
      data: [],
      incidentSubTypes:[],
      incidentTypes:[],
      landmark: null
    };

    this.submitForm = this.submitForm.bind( this );
  }

  componentWillReceiveProps( nextProps ) {
    if( !this.props.open && nextProps.open ) {
      this.setState( { landmark: null } );
      this.getData()
    }
  }

  getData() {
    const { toggleAlertError, toggleLoading, activeAccount } = this.props;
    toggleLoading( true );
     //console.log("AddImsLecmodal",activeAccount);
     async.parallel({
      incidentTypes: (cb) => {
        IncmsService.getIncidentTypes( ).then( ( response ) => {
              toggleLoading( false );
              if ( response.errors ) toggleAlertError( response.errors );
              this.setState( {incidentTypes: response.data } )
              
            } );
      },
      landmark: ( cb ) => {
        IncmsService.getLandmark( this.props.activeAccount.id ).then( ( response ) => {
          if( !response.data ) return cb();
          return cb( null, response.data && response.data.landmark ? response.data.landmark : null );
        } )
      }
     },(error,results)=>{
      this.props.toggleLoading( false );
      if( results ) this.setState( results )
     })
  }

  getIncidentSubTypes( id ) {
    const { toggleAlertError, toggleLoading } = this.props;
    toggleLoading( true );

    IncmsService.getIncidentSubTypes( id ).then( ( response ) => {
      toggleLoading( false );
      if ( response.errors ) toggleAlertError( response.errors );
      this.setState( {incidentSubTypes: response.data } )
      
    } );
  }

  submitForm( data ) {
    const { channel, onClose, onReloadData, toggleAlertError, toggleLoading } = this.props;

    toggleLoading( true );

    data.channel = channel.id;
    data.typeCase = 'ims';
    data.account = this.props.activeAccount.id;
    ChannelCaseService.saveCase( data ).then( ( response ) => {
      toggleLoading( false );
      if( response.errors ) return toggleAlertError( response.errors );

      this.props.toggleAlertError( `Outage: ${response.data.element || '---'}. Description: ${response.data.description || '---'}`, response.data.description );
      onReloadData( channel.id );
      onClose()
    } )
  }

  render() {
    const { onClose, open, activeAccount } = this.props;

    return (
      <Modal closeOnEsc={false}
             closeOnOverlayClick={false}
             little
             modalClassName="col-md-6"
             open={open}
             onClose={onClose}>
        <h5 className="mt-0"><Translate id="addIMS"/></h5>

        <Form onSubmit={this.submitForm}
              defaultValues={{ 
                customerName: activeAccount.incmsDataobj ? _.trim(activeAccount.incmsDataobj.fullName) : '', 
                phoneNumber: activeAccount.incmsDataobj ? activeAccount.incmsDataobj.phone: ''  ,
                imsNature: this.state.imsNature,
                imsLandmark: this.state.landmark 
                }}
              validate={( values ) => ( {
                phoneNumber: required( values.phoneNumber ), 
                imsNature: required( values.imsNature ),
                imsScope: required( values.imsScope ),
                registerComment: required( values.registerComment ),
                customerName: required( values.customerName ),
                imsLandmark: required( values.imsLandmark ),
              } )}
        >
          {( { getValue, submitForm } ) =>
            <form onSubmit={submitForm}>
              <div className="row">
                <FormGroup containerClass="col-md-6">
                  <label><Translate id="customerName"/></label>
                  <Text field="customerName" className="form-control"/>
                </FormGroup>
                <FormGroup containerClass="col-md-6">
                  <label><Translate id="phone"/></label>
                  <Text field="phoneNumber" className="form-control" placeholder="phonePlaceHolder"/>
                </FormGroup>
              </div>

              <div className="row">
                <FormGroup containerClass="col-md-6">
                  <label><Translate id="incidentType"/></label>
                  <Select field="imsNature" className="form-control" placeholder=""
                          labelKey="description"
                          onChange={( value ) => {
                            this.getIncidentSubTypes(value)
                            this.setState( { imsNature: value } )
                          }}
                          options={this.state.incidentTypes}
                          matchPos="start"
                          matchProp="description"
                          />
                </FormGroup>

                <FormGroup containerClass="col-md-6">
                  <label><Translate id="incidentSubType"/></label>
                  <Select field="imsScope" className="form-control" placeholder=""
                          labelKey="description"
                          options={this.state.incidentSubTypes}
                          matchPos="start"
                          matchProp="description"
                          />
                </FormGroup>
              </div>

              <FormGroup>
                <label><Translate id="imsComment"/></label>
                <Textarea field="registerComment" className="form-control"/>
              </FormGroup>
              <div className="row">
                <FormGroup containerClass="col-md-12">
                  <label><Translate id="landmark"/></label>
                  <Textarea field="imsLandmark" className="form-control"/>
                </FormGroup>
              </div>

              <div className="text-right">
                <button className="btn btn-info"><Translate id="submit"/></button>
              </div>
            </form>
          }
        </Form>
      </Modal>
    )
  }
}

const mapDispatchToProps = dispatch => ( {
  toggleAlertError: ( message, msgToCopy ) => {
    dispatch( toggleAlertError( message, msgToCopy ) );
  },
  toggleLoading: ( isLoading ) => {
    dispatch( toggleLoading( isLoading ) );
  },
} );

module.exports = connect(
  null,
  mapDispatchToProps
)( AddImsLECModal );




// WEBPACK FOOTER //
// ./routes/app/components/Agent/AddImsLECModal/index.js